jQuery( document ).ready(function() {


    let $ = jQuery;

    if($("#check-popup").length) {
        console.log("checking for main popup");
        let sendData = {
            action: 'check_popup',
        };

        $.ajax({
            url: ajaxadminurl.ajaxurl,
            type: 'GET',
            data: sendData,
            dataType: 'html',
            cache: false,
            timeout: 10000,
            success: function(popup) {
                if (popup !== 'cookie-exists') {
                    $("body").append(popup);
                } else {
                    console.log('Popup Not needed');
                }
            },
        });
    }


    $(document).on('click', '.mso-emergency-popup .close', function (e) {
        $(".popup-background").fadeOut(500);
        $(".mso-emergency-popup").fadeOut(500);
    });

});